// extracted by mini-css-extract-plugin
export default {"container":"GDPRScreen_container__7xemt","content":"GDPRScreen_content__QyPq7"};